import { z } from "zod"
import { AlfredQuote } from "./alfred-pricing"

/** A named version of a package built for one store. */
export interface AlfredStoreOffer {
  id: string
  name: string
  moduleIds: string[]
  quote: AlfredQuote
  updatedAt: Date
}

/** Everything julo.se/alfred/offer/<store-slug> shows, oldest version first. */
export interface AlfredStoreOfferPage {
  store: { name: string; slug: string }
  offers: AlfredStoreOffer[]
}

export const UpsertAlfredStoreOfferSchema = z.object({
  name: z.string().trim().min(1, "Namnet får inte vara tomt").max(100),
  moduleIds: z.array(z.string().uuid()).max(200),
})
export type UpsertAlfredStoreOffer = z.infer<
  typeof UpsertAlfredStoreOfferSchema
>
